import React, { useState } from "react";
import axios from "axios";
import { Box, Button, Input, TextField, Typography } from "@mui/material";
import Navbar from "../Navbar";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function Login() {

  //usestate declaration
  const navigate = useNavigate();
  const [loginInput, setLogin] = useState({
    email: "",
    password: "",
    error_list: [],
  });

  //color palette
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  //function to handle input
  const handleInput = (e) => {
    e.persist();
    setLogin({ ...loginInput, [e.target.name]: e.target.value });
  };

  //Submit function
  const loginSubmit = (e) => {
    e.preventDefault();

    const data = {
      email: loginInput.email,
      password: loginInput.password,
    };

    //api calling for sanctum
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/login`, data).then((res) => {
        if (res.data.status === 200) {
          localStorage.setItem("auth_id", res.data.userid);
          localStorage.setItem("auth_token", res.data.token);
          localStorage.setItem("auth_name", res.data.username);
          swal("Success", res.data.message, "success");
          navigate("/certificates");
        } else if (res.data.status === 401) {
          swal("Warning", res.data.message, "warning");
        } else {
          setLogin({ ...loginInput, error_list: res.data.validation_errors });
        }
      });
    });
  };

  //main function
  return (
    <div>
      <Navbar />
      <form onSubmit={loginSubmit}>
        <Box
          display="flex"
          flexDirection={"column"}
          maxWidth={400}
          alignItems="center"
          justifyContent={"center"}
          margin="auto"
          marginTop={5}
          padding={3}
          borderRadius={5}
          boxShadow={"5px 5px 10px #ccc"}
          sx={{
            ":hover": {
              boxShadow: "10px 10px 20px #ccc",
            },
          }}
        >
          <Typography variant="h2" padding={3} textAlgin="center">
            Login
          </Typography>
          <TextField
            onChange={handleInput}
            name="email"
            value={loginInput.email}
            margin="normal"
            type={"email"}
            variant="outlined"
            placeholder="Email"
          />
          <span>{loginInput.error_list.email}</span>
          <TextField
            onChange={handleInput}
            name="password"
            value={loginInput.password}
            margin="normal"
            type={"password"}
            variant="outlined"
            placeholder="Password"
          />
          <span>{loginInput.error_list.password}</span>
          <ThemeProvider theme={theme}>
            <Button
              type="submit"
              sx={{ marginTop: 3, borderRadius: 3 }}
              variant="contained"
              color="apple"
            >
              Login
            </Button>
          </ThemeProvider>
        </Box>
      </form>
    </div>
  );
}

export default Login;
